import { handleActions } from "redux-actions";
import { changeAbTestVersion, runAbTest } from "./actions";
import { abTestVersions } from "./constants";

/**
 * Initial state of the AB test reducer
 * @type {{running: boolean, version: string}}
 */
export const abTestInitialState = {
  running: false,
  version: abTestVersions.control,
};

/**
 * Handle the enable AB test action
 * @param state {typeof abTestInitialState}
 * @param payload {{enabled?: boolean}}
 */
const handleRunAbTest = (state, { payload: running = true }) => ({
  ...state,
  running,
});

/**
 * Handle the change AB test version action
 * @param state {typeof abTestInitialState}
 * @param payload {{version?: string}}
 */
const handleChangeAbTestVersion = (
  state,
  { payload: version = abTestVersions.control }
) => ({
  ...state,
  version,
});

export const abTestReducer = handleActions(
  {
    [runAbTest]: handleRunAbTest,
    [changeAbTestVersion]: handleChangeAbTestVersion,
  },
  abTestInitialState
);
